export async function post(url: string, data: object) {
  return await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    // @ts-ignore
    body: new URLSearchParams(data),
  });
}
